import { DPI_DISPLAY, MM_PER_INCH } from '@/utils/math/consts';

export const mmToPt = (mm: number) => (mm * DPI_DISPLAY) / MM_PER_INCH;
